import { FC } from "react";

import styles from "./Loader.module.scss";
import { Loader as LoaderIcon } from "src/assets/icons";

export const Loader: FC = () => <LoaderIcon className={styles.wrapper} />;
